
import Dom7 from 'Dom7';
var $$ =Dom7;

let scrollLeftset = 0;
export default function slideOnTab(index) {

    var el="tab-"+parseInt(index+1);
    let boxWidth = $$('div.toolbar-inner').width();
    //console.log("boxWidth="+boxWidth+" / "+el);
    let tabWidth = $$('a[data-tab="#' + el + '"]').outerWidth();
    let coords = $$('a[data-tab="#' + el + '"]').offset();
   // tabWidth = Math.floor(tabWidth);
    //console.log("tabWidth="+tabWidth+" / "+coords);
    let coordLeft = Math.floor(coords.left);

    if (boxWidth < coordLeft + tabWidth) {

        if (scrollLeftset == coordLeft) {
            $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(coordLeft + tabWidth, 100);
            scrollLeftset = coordLeft + tabWidth;
        } else if ((scrollLeftset <= coordLeft + tabWidth) & (scrollLeftset >= 200)) {
            $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(coordLeft + tabWidth, 100);
            scrollLeftset = coordLeft + tabWidth;
        
        } else if ((scrollLeftset >= coordLeft + tabWidth) & (scrollLeftset >= boxWidth)) {
            $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(scrollLeftset + tabWidth, 100);
            scrollLeftset = scrollLeftset + tabWidth;
            
        } else {
            $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(coordLeft, 100);
            scrollLeftset = coordLeft;
        
        }

    } else if (coordLeft < 0) {
        let leftAdd = Math.abs(coordLeft);
        if (scrollLeftset < tabWidth) {
            $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(0, 100);
            scrollLeftset = 0;
        } else {
            if (scrollLeftset - (tabWidth + leftAdd) < 0) {
                $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(0, 100);
                scrollLeftset = 0;
            } else {

                if (boxWidth < scrollLeftset + leftAdd) {
                    $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(scrollLeftset + leftAdd - boxWidth, 100);
                    scrollLeftset = scrollLeftset + leftAdd - boxWidth;
                } else {
                    $$('div.tabbar-scrollable>div.toolbar-inner').scrollLeft(scrollLeftset - (tabWidth + leftAdd), 100);
                }
                scrollLeftset = scrollLeftset - (tabWidth + leftAdd);
            }
          
        }

      
    }
 
   // console.log("tab:" + tabWidth + " 미작동/left:" + coordLeft + "/leftset" + scrollLeftset);
   
}